export const ResourceLookUpConstants = {
    CANCEL_ASSIGNMENT: 'Cancel Assignment',
    MODAL_TEXT: 'Are you sure you want to cancel the assignment of this job to',
    DONT_CANCEL: "Don't Cancel Assignment",
    ASSIGNED: 'Assigned',
    TO: 'to',
    EMPTY_SPACE: ' ',
    QUESTION: ' ?',
    REASSIGNMENT: 'Reassignment',
    CANCEL_REASSIGNMENT: 'CancelReassign',
    ASSIGN_TO: 'Assign To...',
    MODULE_PREFIX: 'RESOURCE_LOOKUP',
    MILES: 'Miles',
    NO_RECORD_FOUND: 'No record found',
    SEARCHBY_ZIP_POSTALCODE: 'Search by Zip/Postal code',
    KILOMETER: 'KM',
    CONVERT_MILES_TO_KM: 1.60934,
    HIGHLIGHT_TEXT: 'Carrier Preferred'
};
//# sourceMappingURL=ResourceLookUpConstants.js.map